import type { DefaultParamType } from '@tolgee/react';
import type { CombinedOptions } from '@tolgee/react';
import { setLocale } from 'yup';

const DEFAULT_YUP_KEYS_PREFIX = 'shared.yup.defaults';

export const setYupLocale = (
  translate: (
    key: string,
    options?: CombinedOptions<DefaultParamType>,
  ) => string,
) => {
  return setLocale({
    mixed: {
      default: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.mixed.default`),
      required: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.mixed.required`),
      oneOf: ({ values }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.mixed.oneOf`, { values }),
      notOneOf: ({ values }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.mixed.notOneOf`, { values }),
      notType: ({ type }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.mixed.notType`, { type }),
      defined: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.mixed.defined`),
    },
    string: {
      length: ({ length }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.length`, { length }),
      min: ({ min }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.min`, { min }),
      max: ({ max }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.max`, { max }),
      matches: ({ regex }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.matches`),
      email: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.email`),
      url: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.url`),
      uuid: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.uuid`),
      trim: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.trim`),
      lowercase: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.lowercase`),
      uppercase: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.string.uppercase`),
    },
    number: {
      min: ({ min }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.number.min`, { min }),
      max: ({ max }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.number.max`, { max }),
      lessThan: ({ less }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.number.lessThan`, { less }),
      moreThan: ({ more }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.number.moreThan`, { more }),
      positive: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.number.positive`),
      negative: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.number.negative`),
      integer: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.number.integer`),
    },
    date: {
      min: ({ min }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.date.min`, { min }),
      max: ({ max }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.date.max`, { max }),
    },
    boolean: {
      isValue: ({ value }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.boolean.isValue`, { value }),
    },
    object: {
      noUnknown: () => translate(`${DEFAULT_YUP_KEYS_PREFIX}.object.noUnknown`),
    },
    array: {
      length: ({ length }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.array.length`, { length }),
      min: ({ min }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.array.min`, { min }),
      max: ({ max }) =>
        translate(`${DEFAULT_YUP_KEYS_PREFIX}.array.max`, { max }),
    },
  });
};
